import React from 'react';
import {VERIFY,CHANGE} from '../constants/constants';
import {postData} from '../constants/Utils';
import Swal from 'sweetalert2';
import logo from '../assets/logo.png'

class LinkchangePass extends React.Component {

    constructor(props){
        super(props);
        this.state={            
            verify:false
        }
        this.redirect = this.redirect.bind(this);
    }

    redirect(value){
        this.props.redirectTo(value);
    }

    verifyAccount(){
        var user = this.refs.username.value;
        var pswd = this.refs.password.value;        
        var req = {
            'username':user,
            'password':pswd
        }
        if(user !=="" && pswd !==""){ 
            postData(VERIFY,req).then(result => {
                if(result.success!==undefined || result.success!==null ){
                    if(result.success){
                        this.setState({
                            verify:result.success
                        });
                    }else{
                        Swal({
                            title: 'Error',
                            text: result.message,
                            type: 'warning',
                            cancelButtonText: 'Aceptar'
                          }).then((result) => {                              
                          })
                    }
                }
                if(result.status===400){
                    Swal({
                        title: 'Error',
                        text: result.resultMessage,
                        type: 'warning',
                        cancelButtonText: 'Aceptar'
                      }).then((result) => {
                      })
                }                
            });
        }

    }
    changePassword(){
        var user = this.refs.username.value;
        var pswd = this.refs.password.value;        
        var cnfr = this.refs.passwordConfirm.value;
        var newp = this.refs.passwordNew.value;
        var req = {
            'username':user,
            'password':pswd,
            'passwordNew':newp,
            'passwordConfirm':cnfr
        }
        if(this.state.verify && (newp===cnfr?true:false) ){
            postData(CHANGE,req).then(result =>{
                if(result.success){
                    Swal({
                        title: 'Completado',
                        text: result.message,
                        type: 'success',
                        showConfirmButton: true
                      }).then((result) => { 
                        this.redirect('Login');
                      })
                }else{
                    Swal({
                        title: 'Error',
                        text: result.resultMessage,
                        type: 'warning',
                        showConfirmButton: true
                      }).then((result) => {                           
                      })
                }
            });
        }else{
            Swal({
                title: 'Error',
                text: 'Las contraseñas no coinciden.',
                type: 'warning',
                showConfirmButton: true
              }).then((result) => {                           
              })
        }

    }

    render() {
        return (
            <div className="container">
                <div className="row justify-content-center signup-form">
                    <div className=" col-12 col-md-9 col-lg-6 pt-20">
                        <div className="card signup-card">
                            <div className="card-head text-center px-15 p-md-15 bg-dark">
                                <div className="cp-logo pt-15">
                                    <img alt="ClubPremier" width="80%" src={logo} />
                                </div>
                            </div>
                            <div className="card-body px-15 p-md-30 ">
                                <div className="row justify-content-center">
                                    <div className="col-11 col-md-11 pt-11 text-center">
                                        <h2 className=" mb-20">Cambiar contraseña</h2>
                                    </div>
                                    <div className="col-11 p-10">
                                        <input className="form-control p-10" ref="username" name="username" placeholder="Ingrese su usuario" required />
                                    </div>
                                    <div className="col-11 p-10">
                                        <input className="form-control p-10" ref="password" name="password" type="password"  placeholder="Ingrese su contraseña anterior" onBlur={this.verifyAccount.bind(this)}  required/>
                                    </div>
                                    <div className="col-11 p-10">
                                        <input className="form-control p-10" ref="passwordNew" name="password" type="password"  placeholder="Ingrese su nueva contraseña" required />
                                    </div>
                                    <div className="col-11 p-10">
                                        <input className="form-control p-10" ref="passwordConfirm" name="password" type="password"  placeholder="Confirme nueva contraseña" required/>
                                    </div>
                               
                                   
                                    <div className="col-8 pt-30 ">
                                    <button className="col-12 btn btn-color-blue  p-10" onClick={this.changePassword.bind(this)}>Guardar</button>

                                        <div className="text-center pt-15">
                                            <a href="" onClick={this.redirect.bind(this,'Login')}>
                                                Cancelar</a></div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
export default LinkchangePass;



// WEBPACK FOOTER //
// ./src/components/LinkchangePass.js